
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/properties/new",
      function () {
        return require("private-next-pages/admin/properties/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/properties/new"])
      });
    }
  